import React from "react";

export default function StatsCards({ stats = [] }) {
  return (
    <div className="tw-w-full tw-grid tw-grid-cols-2 sm:tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-4">
      {stats.map((item, index) => (
        <div
          key={index}
          className="tw-border-2 tw-border-gray-700 tw-rounded-xl tw-bg-white tw-py-6 tw-px-4 tw-text-center tw-shadow-sm"
        >
          <div className="tw-text-2xl md:tw-text-3xl tw-font-semibold tw-text-gray-800">
            {item.value}
          </div>
          <div className="tw-mt-2 tw-text-sm md:tw-text-base tw-text-gray-500 tw-uppercase tw-tracking-wide">
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
}
